import ConstrucaoProtocolos from './ConstrucaoProtocolos';

export default ConstrucaoProtocolos;
